// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TrafficconfigGcpProperties
 */
export interface TrafficconfigGcpProperties {
  /**
   *
   * @type {Array<string>}
   * @memberof TrafficconfigGcpProperties
   */
  projectIds: Array<string>;
}

/**
 * Check if a given object implements the TrafficconfigGcpProperties interface.
 */
export function instanceOfTrafficconfigGcpProperties(
  value: object,
): value is TrafficconfigGcpProperties {
  if (!('projectIds' in value) || value['projectIds'] === undefined)
    return false;
  return true;
}

export function TrafficconfigGcpPropertiesFromJSON(
  json: any,
): TrafficconfigGcpProperties {
  return TrafficconfigGcpPropertiesFromJSONTyped(json, false);
}

export function TrafficconfigGcpPropertiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrafficconfigGcpProperties {
  if (json == null) {
    return json;
  }
  return {
    projectIds: json['project_ids'],
  };
}

export function TrafficconfigGcpPropertiesToJSON(
  json: any,
): TrafficconfigGcpProperties {
  return TrafficconfigGcpPropertiesToJSONTyped(json, false);
}

export function TrafficconfigGcpPropertiesToJSONTyped(
  value?: TrafficconfigGcpProperties | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    project_ids: value['projectIds'],
  };
}
